<template>
    <div id="eventsGallery">
      <Vue3Marquee :duration="40" :clone="true" :pauseOnHover="true">
        <img
          v-for="(image, i) in images"
          :key="i"
          :src="require(`@/assets/images/eventGallery/${image}`)"
          alt=""
        />
      </Vue3Marquee>
    </div>
  </template>
  
  <script>
  import { Vue3Marquee } from "vue3-marquee";
  
  export default {
    name: "EventsGallery",
    components: {
      Vue3Marquee,
    },
    data() {
      return {
        images: [
          "event1.jpg",
          "event2.jpg",
          "event3.jpg",
          "event4.jpg",
          "event5.jpg",
          "event6.jpg",
          "event7.jpg",
          "event8.jpg",
          "event9.jpg",
          "event10.jpg",
          "event11.jpg",
          "event12.jpg",
        ],
      };
    },
    methods: {},
  };
  </script>
  <style lang="scss">
  #eventsGallery {
    .vue3-marquee {
      .marquee {
        min-width: fit-content;
  
        img {
          height: 150px;
        }
      }
    }
  }
  </style>
  